import {
    useEffect,
    useState,
} from 'react';

// FNP-815: module-scoped keyword store. The search box lives in
// SimpleTableBatchAction and the filtering lives in usePersonas — different
// components. A local useState would give each its own copy and search would
// silently never filter. Do not replace this with a local useState.
let globalKeyword = '';
const keywordListeners: Set<(keyword: string) => void> = new Set();

const notifyKeywordChange = (keyword: string) => {
    globalKeyword = keyword;
    keywordListeners.forEach(listener => listener(keyword));
};

export const usePersonasSearch = () => {
    const [keyword, setKeyword] = useState<string>(globalKeyword);

    useEffect(() => {
        const listener = (newKeyword: string) => {
            setKeyword(newKeyword);
        };
        keywordListeners.add(listener);
        return () => {
            keywordListeners.delete(listener);
        };
    }, []);

    const handleFilterByKeyword = (newKeyword: string) => {
        notifyKeywordChange(newKeyword);
    };

    return {
        keyword,
        handleFilterByKeyword,
    };
};
